
document.addEventListener("mb:cart:changed", (e) => {
    const sections = e.detail.cart.sections;

    updateCartDrawer('[data-mb-cart-drawer]', getSectionDom(sections, 'mb-cart-drawer'));
    updateCartPage('[data-mb-cart-page]', getSectionDom(sections, 'mb-cart'));
    updateToolbarQty('[data-mb-header-toolbar]', getSectionDom(sections, 'header'));
    document.dispatchEvent(new CustomEvent("mb:cart:rendered"));
});

function getSectionDom(sections, selector) {
    if (!sections || !selector) return;
    const htmlString = sections[selector];
    if (!htmlString) return

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    return doc;

}


function updateCartDrawer(rootSelector, doc) {
    const root = document.querySelector(rootSelector);
    if (!root) return;

    const items = root.querySelector('.mb-drawer-panel__products')
    const new_items = doc.querySelector('.mb-drawer-panel__products')
    if (items && new_items) items.replaceWith(new_items);


    const drawer_footer = root.querySelector('.mb-drawer-panel__footer')
    const new_drawer_footer = doc.querySelector('.mb-drawer-panel__footer')
    if (drawer_footer && new_drawer_footer)
        drawer_footer.replaceWith(new_drawer_footer);

    const extraInputs = root.querySelector('[data-mb-cart-extra-inputs]');
    const new_extraInputs = doc.querySelector('[data-mb-cart-extra-inputs]');
    if (extraInputs && new_extraInputs)
        extraInputs.replaceWith(new_extraInputs);

    const agreementCheck = root.querySelector('input[name="attributes[terms_agreement]"]');
    const new_agreementCheck = doc.querySelector('input[name="attributes[terms_agreement]"]');
    if (agreementCheck && new_agreementCheck)
        agreementCheck.replaceWith(new_agreementCheck);

    const shippingUpsell = root.querySelector('.mb-shipping-upsell');
    const new_shippingUpsell = doc.querySelector('.mb-shipping-upsell');
    if (shippingUpsell && new_shippingUpsell)
        shippingUpsell.replaceWith(new_shippingUpsell);



}



function updateCartPage(rootSelector, doc) {
    const root = document.querySelector(rootSelector);
    if (!root) return;

    const items = root.querySelector('.mb-cart__items')
    const new_items = doc.querySelector('.mb-cart__items')
    if (items && new_items) items.replaceWith(new_items);

    const total = root.querySelector('[data-mb-cart-total]')
    const new_total = doc.querySelector('[data-mb-cart-total]')
    if (total && new_total) total.replaceWith(new_total);

    const checkout = root.querySelector('.mb-cart__summary-order')
    const new_checkout = doc.querySelector('.mb-cart__summary-order')
    if (checkout && new_checkout) checkout.replaceWith(new_checkout);

    const extraInputs = root.querySelector('[data-mb-cart-extra-inputs]');
    const new_extraInputs = doc.querySelector('[data-mb-cart-extra-inputs]');
    if (extraInputs && new_extraInputs)
        extraInputs.replaceWith(new_extraInputs);

    const agreementCheck = root.querySelector('input[name="attributes[terms_agreement]"]');
    const new_agreementCheck = doc.querySelector('input[name="attributes[terms_agreement]"]');
    if (agreementCheck && new_agreementCheck)
        agreementCheck.replaceWith(new_agreementCheck);

    const shippingUpsell = root.querySelector('.mb-shipping-upsell');
    const new_shippingUpsell = doc.querySelector('.mb-shipping-upsell');
    if (shippingUpsell && new_shippingUpsell)
        shippingUpsell.replaceWith(new_shippingUpsell);

}

function updateToolbarQty(rootSelector, doc) {
    const root = document.querySelector(rootSelector);
    if (!root) return;

    const bubble = root.querySelector('[data-toolbar-cart-qty]')
    const new_bubble = doc.querySelector('[data-toolbar-cart-qty]')
    if (bubble && new_bubble) bubble.replaceWith(new_bubble);

}